export const TITLE = 'Attract more followers and boost your popularity with smart tags';

export const BENEFIT = [{
	svgIcon: 'graph',
	title: 'Smart tags',
	textBegin: 'Our algorithms analyze thousands of hashtags and offer the most relevant results.',
	textSecond: true,
	textHighlight: 'Artificial Intelligence (AI) is perfectly used',
	otherText: ' to ensure only concise and proper tags for your photos.'
}, {
	svgIcon: 'time',
	title: 'Fast and easy tool',
	textBegin: 'Overwhelming ',
	textHighlight: 'results will be delivered in 0.001 seconds.',
	otherText: ' An intuitive design and minimalistic interface make this app the easiest you have ever tried.'
}, {
	svgIcon: 'like',
	title: 'Efficient solution for popularity',
	textBegin: 'We help to increase engagement with your posts and ',
	textHighlight: 'multiply the number of your followers',
	otherText: ' on social media. This tool is an incredible solution for both popularity and marketing.'
}];

export const INTEREST = [{
	title: 'Get relevant tags',
	text: 'Upload a photo and the app will offer the relevant hashtags immediately. It knows your location, so you never miss trends.'
}, {
	title: 'Experience a magical tool',
	text: 'Algorithms know how to build the list of tags you need. The results combine geotags, tags related to a photo, and popular tags for effective promotion.'
}, {
	title: 'Customize it',
	text: 'The list of smart tags is at your disposal. Delete unwanted hashtags or add your own to increase engagement with your posts.'
}, {
	title: 'Come again',
	text: 'Get quick access to all of the hashtags for your picture content. The app automatically saves them in its History.'
}];

export const SOCIAL_TITLE = 'Great tags for popular social networks';

export const FOOTER_TITLE = 'Add the most relevant hashtags to your pictures';

export const FOOTER_APP_TEXT = 'The app is available for free on the App Store.';

export const COPYRIGHT = 'Product by dizzain.com';

export const TESTIMONIALS_TITLE = 'This app is chosen by professionals';
export const TESTIMONIALS_DESCRIPTION = 'Bloggers and marketing professionals call Ainstags the most efficient tool for personal and business purposes.';
export const TESTIMONIALS = [{
	name: 'Tania',
	position: 'Singer and blogger',
	text: 'Great job! I tried several similar apps, but this one is the best. It gives all the relevant results as well as being fast and simple to use. What I like most is that you can share the hashtags whenever you need, by Instagram, Twitter or even email.'
}, {
	name: 'Roman',
	position: 'Sports blogger',
	text: 'I love the design and minimalistic interface. These hashtags are trendy, but not overused. I can add my own tags and delete the hashtags generated by this app. It’s very useful. Thank you for the app!'
}, {
	name: 'Tatsiana',
	position: 'Social media manager',
	text: 'I can save hours everyday, really! It’s an incredibly helpful solution for SMM. Advanced settings are highly recommended. The app is fast, and the hashtags are suitable, relevant. I didn’t find any bugs during my first 2 weeks of usage.'
}];


// WEBPACK FOOTER //
// ./src/constants/index.js